<template>
  <div class="are-content">
    <el-card>
      <div class="mb10 feet-r">
        <!--添加-->
        <el-button
          v-permit:remove="'btn:finance:basicData:districtManagement:add'"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handlerOperation(1)"
        >{{ $t('basicData.Add') }}
        </el-button>
        <!--导入-->
        <el-button
          v-permit:remove="'btn:finance:basicData:districtManagement:import'"
          size="small"
          type="primary"
          icon="el-icon-upload2"
          class="feet-btn"
          @click="handlerOperation(2)"
        >{{ $t('CenterForSorting.Import') }}
        </el-button>
        <!--导出-->
        <el-button
          v-permit:remove="'btn:finance:basicData:districtManagement:export'"
          size="small"
          icon="el-icon-download"
          class="feet-btn"
          @click="handlerOperation(3)"
        >{{ $t('CenterForSorting.export') }}
        </el-button>
        <!--批量删除-->
        <el-button
          v-permit:remove="'btn:finance:basicData:districtManagement:delAll'"
          size="small"
          type="danger"
          class="feet-btn"
          :disabled="isDisable"
          @click="deleteData({},1)"
        >{{ $t('basicData.Delete') }}
        </el-button>
        <!-- 搜索-->
        <el-input
          v-model="searchCode"
          :placeholder="$t('basicData.zipCode')"
          size="small"
          clearable
          style="width: 350px"
          @clear="clearHighlight"
        >
          <template #prepend>{{ $t('basicData.zipCode') }}</template>
          <template #append>
            <el-button icon="el-icon-search" @click="handleSearch" />
          </template>
        </el-input>
        <el-button-group>
          <el-button
            :disabled="!hasSearchResults || currentHighlightIndex <= 0"
            size="small" icon="el-icon-arrow-left"
            @click="highlightPrev"
          >{{ $t('mdfeTranslate.Previous') }}</el-button>
          <el-button
            :disabled="!hasSearchResults" size="small"
            type="primary"
          >
            {{ currentHighlightIndex + 1 }}/{{ searchResults.length }}
          </el-button>
          <el-button
            :disabled="!hasSearchResults || currentHighlightIndex >= searchResults.length - 1"
            size="small" @click="highlightNext"
          >{{ $t('mdfeTranslate.Next') }}
            <i class="el-icon-arrow-right el-icon--right" /></el-button>
        </el-button-group>
      </div>

      <el-table
        ref="elTable"
        :data="tableData"
        border
        class="table-height"
        :height="tableHeight"
        :row-class-name="getRowClassName"
        :highlight-current-row="false"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          :reserve-selection="true" align="center" type="selection"
          width="55"
        />
        <el-table-column :label="$t('operationCenter.ind')" width="80px" align="center">
          <template v-slot="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--州-->
        <el-table-column
          prop="twoCode"
          :label="$t('GlobalSetObj.state')"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <div style="color: #409eff;cursor: pointer;" @click="handlerOperation(4, scope.row)">{{ scope.row.twoCode }}</div>
          </template>
        </el-table-column>
        <!--城市-->
        <el-table-column
          prop="cityName"
          :label="$t('orderCenterCont.city')"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        />
        <!--邮编-->
        <el-table-column
          prop="zipCode"
          :label="$t('GlobalSetObj.zipCode')"
          align="center"
          min-width="200"
          :show-overflow-tooltip="true"
        />
        <!--创建人-->
        <el-table-column
          prop="createUserStr"
          :label="$t('basicData.CreatePeople')"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        />
        <!--创建时间-->
        <el-table-column
          prop="createTime"
          :label="$t('basicData.CreationTime')"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        />
        <!--最后修改人-->
        <el-table-column
          prop="updateUserStr"
          :label="$t('basicData.LastModifier')"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        />
        <!--最后修改时间-->
        <el-table-column
          prop="updateTime"
          :label="$t('basicData.LastModified')"
          align="center"
          min-width="160"
          :show-overflow-tooltip="true"
        />
        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="160"
          fixed="right"
        >
          <template v-slot="scope">
            <div class="feet-r">
              <el-button
                v-permit:remove="'btn:finance:basicData:districtManagement:add'"
                size="mini" type="primary"
                @click="handlerOperation(5, scope.row)"
              >{{ $t('basicData.Edit') }}</el-button>
              <el-button
                v-permit:remove="'btn:finance:basicData:districtManagement:del'"
                size="mini" type="danger"
                @click="deleteData(scope.row, 2)"
              >{{ $t('basicData.Delete') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="pageNumber"
          :page-sizes="[50, 100, 200]"
          :page-size.sync="pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrencyTableData"
          @size-change="getSizeTableData"
        />
      </div>
    </el-card>

    <!--    新增/编辑-->
    <el-drawer
      :title="title"
      :append-to-body="true"
      :visible.sync="showDetail"
      direction="ltr"
      size="40%"
    >
      <el-form
        ref="formParamData"
        :key="showDetail"
        class="queryFormClass"
        label-width="auto"
        label-position="top"
        size="small"
        :model="formParam"
        :disabled="operationType === 4"
      >
        <!--州-->
        <el-form-item
          :label="$t('GlobalSetObj.state')"
          prop="twoCode"
          :rules="[
            { required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
          ]"
        >
          <el-input v-model="formParam.twoCode" :placeholder="$t('orderDetails.pleaseInput')" />
        </el-form-item>
        <!--城市-->
        <el-form-item
          :label="$t('orderCenterCont.city')"
          prop="cityName"
          :rules="[
            { required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
          ]"
        >
          <el-input v-model="formParam.cityName" :placeholder="$t('orderDetails.pleaseInput')" />
        </el-form-item>
        <!--邮编-->
        <el-form-item
          :label="$t('basicData.zipCode')"
          prop="zipCode"
          :rules="[
            { required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
          ]"
        >
          <el-input
            v-model="formParam.zipCode"
            type="textarea"
            :rows="6"
            :placeholder="$t('basicData.ZipCodeExample')"
            @change="zipcodeCollation(formParam.zipCode)"
          />
        </el-form-item>
      </el-form>
      <div v-if="[1,5].includes(operationType)" class="demo-drawer__footer">
        <el-button @click="showDetail = false">{{ $t('basicData.Cancel') }}</el-button>
        <el-button v-permit:remove="'btn:finance:basicData:districtManagement:add'" type="primary" @click="submit">{{ $t('basicData.Save') }}</el-button>
      </div>
    </el-drawer>

    <!--导入新增-->
    <el-dialog
      :title="$t('receivablePayable.ImportAddCharges')"
      :visible.sync="showImportAddFee"
      width="500px"
      :append-to-body="true"
    >
      <importFee @importChange="importChange" />
    </el-dialog>
  </div>
</template>

<script>
import { getUserName } from '@/utils/asyncTools';
import {
  apiGetInlandTransportationFeeAdd,
  apiGetInlandTransportationFeeEdit,
  apiGetInlandTransportationFeePage,
  apiGetInlandTransportationFeeDelete,
  apiGetInlandTransportationFeeExport, apiGetInlandTransportationFeeBatchDelete
} from '@/api/finance/basicData';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { compressList } from '@/utils/zipcode';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'TransportationFee',
  components: {
    importFee: () => import('./importFee.vue')
  },
  data() {
    return {
      title: '',
      pageSize: 50,
      pageNumber: 1,
      tableData: [],
      total: 0,
      userIdAndNameObj: null,
      showDetail: false,
      formParam: {
        id: '',
        twoCode: '',
        cityName: '',
        zipCode: ''
      },
      operationType: 1,
      showImportAddFee: false,
      // 响应式数据
      visibleData: [],
      searchCode: '',
      searchResults: [],
      currentHighlightIndex: -1,
      selectData: []
    };
  },
  computed: {
    // table高度
    tableHeight() {
      return (window.innerHeight - 282);
    },
    hasSearchResults() {
      return this.searchResults.length > 0;
    },
    isDisable() {
      return !this.selectData.length;
    }
  },
  watch: {
    searchCode(newVal) {
      if (!newVal) {
        this.clearHighlight();
      } else {
        this.handleSearch(); // 自动搜索定位
      }
    }
  },
  created() {
    this.userIdAndNameObj = getUserIdAndNameObj();
    // 分页查询
    this.getDataSearch();
  },
  methods: {
    // 导入更新
    importChange() {
      this.showImportAddFee = false;
      this.getDataSearch();
    },
    // 邮编整理
    zipcodeCollation(zipcode) {
      this.formParam.zipCode = compressList(zipcode).join(',');
    },
    // 搜索
    getDataSearch() {
      this.pageNumber = 1;
      this.getTableDate();
    },
    // 当前页面变化
    getCurrencyTableData(val) {
      this.pageNumber = val;
      this.getTableDate();
    },
    // 每页条数变化
    getSizeTableData(val) {
      this.pageNumber = 1;
      this.pageSize = val;
      this.getTableDate();
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 获取列表数据
    getTableDate() {
      apiGetInlandTransportationFeePage({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber
      }).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            item.createUserStr = getUserName(item.createUser, this.userIdAndNameObj);
            item.updateUserStr = getUserName(item.updateUser, this.userIdAndNameObj);
          });
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 删除
    /**
     *  操作 1 批量删除 2 单条删除
     * @param row
     * @param type
     */
    deleteData(row, type) {
      const API = type === 1 ? apiGetInlandTransportationFeeBatchDelete : apiGetInlandTransportationFeeDelete;
      const ids = this.selectData.map(item => item.id);
      const id = type === 1 ? ids : row.id;
      console.log(id, ids);
      this.$confirm(`${this.$t('basicData.AreYouSureDelete')}?`, this.$t('basicData.tips'), {
        confirmButtonText: this.$t('basicData.determine'),
        cancelButtonText: this.$t('basicData.Cancel'),
        type: 'warning'
      }).then(() => {
        API(id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded'));
            this.getDataSearch();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    /**
     *  操作 1 新增 2 导入 3 导出 4 详情 5 修改
     * @param type
     * @param row
     */
    handlerOperation(type, row) {
      this.operationType = type;
      if (type === 1) {
        this.formParam = {
          twoCode: '',
          cityName: '',
          zipCode: ''
        };
        this.title = this.$t('basicData.Add');
        this.showDetail = true;
        return;
      }
      if (type === 4) {
        this.formParam = cloneDeep(row);
        this.title = this.$t('basicData.detail');
        this.showDetail = true;
        return;
      }
      if (type === 5) {
        this.formParam = cloneDeep(row);
        this.title = this.$t('basicData.Edit');
        this.showDetail = true;
        return;
      }
      // 导入
      if (type === 2) {
        this.showImportAddFee = true;
        return;
      }
      // 导出
      if (type === 3) {
        apiGetInlandTransportationFeeExport({}).then(() => {
          goResourceTaskList();
        });
      }
    },
    // 保存
    submit() {
      this.$refs['formParamData'].validate((valid) => {
        if (valid) {
          const param = {
            id: this.formParam.id,
            twoCode: this.formParam.twoCode || '',
            cityName: this.formParam.cityName,
            zipCode: this.formParam.zipCode || ''
          };
          // operationType->1新增
          // operationType->5修改
          const API = this.operationType === 1
            ? apiGetInlandTransportationFeeAdd
            : apiGetInlandTransportationFeeEdit;
          API(param).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded'));
              this.showDetail = false;
              this.getDataSearch();
            }
          });
        }
      });
    },
    // 搜索处理
    handleSearch() {
      const searchTerm = this.searchCode.trim();
      const tableData = this.tableData;

      if (!searchTerm) {
        this.searchResults = [];
        this.currentHighlightIndex = -1;
        return;
      }

      const results = tableData
        .map((row, index) => ({ row, index }))
        .filter(item => {
          const { zipCode } = item.row;
          const postalCodeList = this.parseDataRanges(zipCode);
          console.log('postalCodeList', postalCodeList);
          const {
            matched,
            matchedRange
          } = this.postalCodeFormat(searchTerm, postalCodeList);
          console.log('matched', matched, matchedRange);
          return matched;
        });

      console.log('results', results);
      this.searchResults = results;
      this.currentHighlightIndex = results.length ? 0 : -1;

      if (results.length > 0) {
        this.$nextTick(() => this.scrollToHighlightedRow());
      }
    },

    // 下一个
    highlightNext() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex = (this.currentHighlightIndex + 1) % this.searchResults.length;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 上一个
    highlightPrev() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex =
        this.currentHighlightIndex <= 0
          ? this.searchResults.length - 1
          : this.currentHighlightIndex - 1;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 滚动到当前高亮行
    scrollToHighlightedRow() {
      // 获取表格的虚拟滚动实例
      const virtualScroll = this.$refs.elTable.$el;

      if (this.currentHighlightIndex < 0) return;

      const currentMatch = this.searchResults[this.currentHighlightIndex];
      if (!currentMatch) return;

      const rowIndex = currentMatch.index;

      const rowHeight = 55; // 每行的预计高度，根据实际情况调整
      const viewportHeight = virtualScroll.clientHeight; // 可视区域高度
      // const totalRows = this.formData.partitionAffiliateList.length; // 表格总行数
      const maxRowsInViewport = Math.floor(viewportHeight / rowHeight); // 可视区域最多能显示的行数
      const startIndex = Math.max(0, rowIndex - Math.floor(maxRowsInViewport / 2)); // 计算开始滚动的行索引
      const scrollTop = rowHeight * startIndex; // 计算需要滚动的位置
      console.log('scrollTop', scrollTop, startIndex, rowIndex, maxRowsInViewport, viewportHeight);
      this.setScrollTop(scrollTop);

      // 强制表格重新渲染以应用高亮样式
      this.$nextTick(() => {
        if (this.$refs.elTable && this.$refs.elTable.doLayout) {
          this.$refs.elTable.doLayout();
        }
      });
    },
    // 清空搜索结果
    clearHighlight() {
      this.searchCode = '';
      this.searchResults = [];
      this.currentHighlightIndex = -1;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    // 设置滚动距离
    setScrollTop(top = 0) {
      const tableRef = this.$refs.elTable.$el.querySelector('.el-table__body-wrapper'); // 表格元素
      tableRef.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    },

    // 获取行类名
    getRowClassName({ row, rowIndex }) {
      return this.isRowHighlighted(row, rowIndex) ? 'highlighted-row' : '';
    },

    // 检查行是否高亮
    isRowHighlighted(row, rowIndex) {
      if (this.currentHighlightIndex < 0) return false;

      const currentResult = this.searchResults[this.currentHighlightIndex];
      return currentResult && currentResult.row.id === row.id;
    },
    // 邮编匹配规则
    postalCodeFormat(value, parsedRanges) {
      const number = parseFloat(value);

      let matched = false;
      let matchedRange = null;

      for (const range of parsedRanges) {
        if (range.type === 'single') {
          if (range.value.includes(number)) {
            matched = true;
            matchedRange = range;
            break;
          }
        } else if (range.type === 'range') {
          if (number >= range.start && number <= range.end) {
            matched = true;
            matchedRange = range;
            break;
          }
        }
      }
      return {
        matched,
        matchedRange
      };
    },
    // 邮编解析
    parseDataRanges(code) {
      const ranges = [];
      const parts = code.split(',');

      for (const part of parts) {
        const trimmedPart = part.trim();

        if (trimmedPart.includes('~')) {
          // 处理区间
          const [start, end] = trimmedPart.split('~').map(num => parseFloat(num.trim()));
          if (!isNaN(start) && !isNaN(end)) {
            ranges.push({ type: 'range', start, end });
          }
        } else {
          // 处理单个数字
          const num = parseFloat(trimmedPart);
          if (!isNaN(num)) {
            ranges.push({ type: 'single', value: num.toString() });
          }
        }
      }

      return ranges;
    }
  }
};
</script>

<style scoped lang="scss">
.queryFormClass {
  height: calc(100vh - 136px);
  padding: 15px;
}
.demo-drawer__footer {
  text-align: right;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #ccc;
}

::v-deep .highlighted-row,
::v-deep .highlighted-row:hover > td {
  background-color: #e6f7ff !important;
}

::v-deep .highlighted-row {
  position: relative;
}

::v-deep .highlighted-row::after {
  position: absolute;
  content: '';
  width: 5px;
  height: 100%;
  background-color: #1890ff;
  left: 0;
}

::v-deep .el-table__row {
  transition: all 0.3s ease;
}

</style>
